import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addRecipeCategoryApi, listOfRecipeCategoriesApi, updateRecipeCategoryApi } from "../../../../../config/Api";
import { setHeaderName } from "../../../../../services/SetHeaderName";
import { CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { apiErrorMessage } from "../../../../../services/ApiError";

export const RecipeCategory = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [categoryData, setCategoryData] = useState()
    const [editCategoryRecord, setEditCategoryRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of all available recipe categories 
    //==============================
    const getListOfRecipeCategories = () => {
        setLoading(true)

        listOfRecipeCategoriesApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    //==============================
    const editRecipeCategory = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'category_name': data.name })
        setEditCategoryRecord(data);
    }

    useEffect(() => {
        getListOfRecipeCategories()
        setHeaderName("Recipe Master")
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterCategory(categoryData);
    }, [categoryData]);

    // filter recipe category
    //==============================
    const filterCategory = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe category
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateRecipeCategoryApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Recipe Category Update successfully",
                    });
                    getListOfRecipeCategories()
                }
            })
            .catch((err) => {
                notification.error({
                    message: apiErrorMessage(err),
                });
            });
    };

    const columns = [
        {
            title: 'Category Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editRecipeCategory(record) }} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Veg',
            status: true
        },
        {
            id: '2',
            name: 'Non Veg',
            status: false
        },
        {
            id: '3',
            name: 'Egg',
            status: true
        },
        {
            id: '4',
            name: 'Vegan',
            status: true
        },
        {
            id: '5',
            name: 'Pascetarian',
            status: true
        },
    ];

    // handle submit
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.category_name.trim(),
                "status": true
            }
            addRecipeCategoryApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'category_name': '' })
                        notification.success({
                            message: "Category added successfully",
                        });
                        getListOfRecipeCategories()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: apiErrorMessage(err),
                    });
                });
        }
        else {
            const data = {
                "name": values.category_name.trim(),
                "status": values.status
            }
            updateRecipeCategoryApi(editCategoryRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Category Update successfully",
                        });
                        getListOfRecipeCategories()
                        form.setFieldsValue({ 'category_name': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: apiErrorMessage(err),
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };

    // same name already in the list, ignoring capital letters and surrounding spaces
    // (the category being edited doesn't count, so it can be re-cased)
    const isDuplicateName = (name) => {
        const normalized = (name || '').trim().toLowerCase()
        return dataSource.some((category) =>
            category.name.trim().toLowerCase() === normalized &&
            !(buttonName === 'UPDATE' && category.id === editCategoryRecord?.id)
        )
    }
    return (
        <div className="RecipeCategory">
            <Row>
                <Col md={24} xl={14}>
                    <Form
                        name="addPlanPricingForm"
                        className="addCategory"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addCategoryForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="category_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Recipe Category!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        },
                                        {
                                            validator: (_, value) =>
                                                isDuplicateName(value)
                                                    ? Promise.reject(new Error("This category already exists!"))
                                                    : Promise.resolve(),
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter Recipe Category" className="p-2" />
                                </Form.Item>
                            </Col>

                            <Col xl={8}>
                                <Button htmlType="submit"
                                    className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col md={8} xl={4} className="text-end align-self-center">
                    <h6 className="mb-0">Total: {displayData.length > 0 ? displayData.length : 0} </h6>
                </Col>
                <Col md={16} xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Category"
                        onChange={(e) => { filterCategory(e.target.value); setCategoryData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
